import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var FullScreen = /*#__PURE__*/function () {
  function FullScreen() {
    _classCallCheck(this, FullScreen);
    this.enable = true;
    this.zIndex = 0;
  }
  _createClass(FullScreen, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.zIndex !== undefined) {
        this.zIndex = data.zIndex;
      }
    }
  }]);
  return FullScreen;
}();